import {
	GET_ONGOING_CHALLENGES,
	GET_PAST_CHALLENGES,
	GET_FUTURE_CHALLENGES,
	GET_ALL_CHALLENGES,
	GET_CHALLENGE_DETAIL_INFO,
	GET_MY_CHALLENGES,
	RESET_CHALLENGE_DETAIL_INFO,
	GET_CHALLENGE_PHOTOS,
} from '~/data/constants/challenges-constants';

const initialState = {
	type: null,
	challenges: {
		current: [],
		upcoming: [],
		past: [],
	},
	myChallenges: [],
	challengeDetail: {
		meta: [],
		stats: [],
		photos: {
			small: [],
			large: [],
		},
		standings: {
			individual: [],
			team: [],
			company: [],
		},
	},
};

/**
 * The Snackbar Reducer
 *
 * @param {any} [state=initialState]
 * @param {any} action
 * @returns
 */
function challenges(state = initialState, action) {
	switch (action.type) {
		case GET_ONGOING_CHALLENGES:
			return {
				...state,
				challenges: Object.assign({}, initialState.challenges, {
					current: action.current,
				}),
			};
		case GET_PAST_CHALLENGES:
			return {
				...state,
				challenges: Object.assign({}, initialState.challenges, {
					past: action.past,
				}),
			};
		case GET_FUTURE_CHALLENGES:
			return {
				...state,
				challenges: Object.assign({}, initialState.challenges, {
					upcoming: action.upcoming,
				}),
			};

		case GET_ALL_CHALLENGES:
			return {
				...state,
				challenges: Object.assign({}, initialState.challenges, {
					upcoming: action.future,
					past: action.past,
					current: action.ongoing,
				}),
			};

		case GET_CHALLENGE_DETAIL_INFO:
			return {
				...state,
				challengeDetail: Object.assign({}, initialState.challengeDetail, {
					meta: action.meta,
					stats: action.stats,
					photos: Object.assign({}, initialState.photos, {
						small: action.photos.small,
						large: action.photos.large,
					}),
					standings: Object.assign({}, initialState.standings, {
						individual: action.standings.individual,
						team: action.standings.team,
					}),
				}),
			};
		case RESET_CHALLENGE_DETAIL_INFO:
			return {
				...state,
				challengeDetail: initialState.challengeDetail,
			};
		case GET_MY_CHALLENGES:
			return {
				...state,
				myChallenges: action.myChallenges,
			};
		case GET_CHALLENGE_PHOTOS:
			let photosState = {
				...state,
				challengeDetail: Object.assign({}, state.challengeDetail, {
					photos: {
						small: action.small,
						large: action.large,
					},
				}),
			};
			return photosState;
		default:
			return state;
	}
}

export default challenges;



// WEBPACK FOOTER //
// ./src/redux/reducers/challenges-reducer.jsx